type stateType = {
    id: string;
    translationKey: string;
    color: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
};

type statesCollection = {
    [key: string]: stateType;
};

export const returnStates: statesCollection = {
    requested: {
        id: 'requested',
        translationKey: 'resources.order.return.status.requested',
        color: 'default',
    },
    open: {
        id: 'open',
        translationKey: 'resources.order.return.status.open',
        color: 'primary',
    },
    declined: {
        id: 'declined',
        translationKey: 'resources.order.return.status.declined',
        color: 'error',
    },
    package_received: {
        id: 'package_received',
        translationKey: 'resources.order.return.status.package_received',
        color: 'info',
    },
    package_lost: {
        id: 'package_lost',
        translationKey: 'resources.order.return.status.package_lost',
        color: 'info',
    },
    waiting_for_customer_response: {
        id: 'waiting_for_customer_response',
        translationKey: 'resources.order.return.status.waiting_for_customer_response',
        color: 'warning',
    },
    refunded: {
        id: 'refunded',
        translationKey: 'resources.order.return.status.refunded',
        color: 'success',
    },
    canceled: {
        id: 'canceled',
        translationKey: 'resources.order.return.status.canceled',
        color: 'secondary',
    }
};
